import { IAction } from "@/common/interface";

import { applyMiddleware, createStore } from "redux";
import thunk, { ThunkMiddleware } from "redux-thunk";
import reducers from "./reducers";

export type IIndexState = ReturnType<typeof reducers>;
export * from "./actions";
export const store = createStore(
  reducers,
  applyMiddleware(thunk as ThunkMiddleware<IIndexState, IAction>),
);
